























































































































































    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
	import axios from 'axios';
	import { api } from '@/api';
    import { languagesPayload } from '@/interfaces/Payload';
    import { State, Getter, Action, Mutation } from 'vuex-class';
	
	@Component
	export default class LanguagePicker extends Vue {
        
        @Prop()
        public value: any;

        public languages: any[] = [];

        public get setLanguages(): any[] { return []};

        public set setLanguages( langs: any[] ) {
            this.languages = [];
            langs.forEach((lang: any) => {

                let language = { 
                    ...lang,
                    selected: false,
                    language_level: { id: 0, name: '' }
                };
                
                this.languages.push(language);
            })

        }
        public payload: any = [];
        public nativeLanguage: any = 0;

        public levelSelectDialog: boolean = false;
        public levelSelectedInDialog: any = {
            id: 0,
            name: ''
        };

        public dialogLanguage: any = {
            id: 0,
            name: '',
            language_level: {
                id: 0,
                name: ''
            },
        };

        public levels: any[] = [
            {
                id: 1,
                name: 'Native'
            },
			{
				id: 2,
				name: 'Advance'
			},
			{
				id: 3,
				name: 'Intermediate'
			},
			{
				id: 4,
				name: 'Basic'
			}
        ];

        public prepareSelected(selectedLanguages:any) {

            for (const selectedLanguage in selectedLanguages) {

                let selectedLevel = selectedLanguages[selectedLanguage].language_level

                this.languages.forEach(( language: any ) => {
                    if ( selectedLanguage == language.id ) {
                        language.selected = true;
                        this.levels.forEach(( level: any ) => {
                            if ( level.id == selectedLevel ) {
                                language.language_level.id = level.id; 
                                language.language_level.name = level.name;
                            }
                        })
                    }
                })

                this.sortLanguages();
            }
        }

        public sortLanguages() {
            this.languages.sort((a: any, b: any) => b.selected ? 1 : -1);
        }

        public selectLangLevel( language:any ) {
            this.levelSelectDialog = true;
            this.dialogLanguage = language;
            this.levelSelectedInDialog = language.language_level
        }

        public setLanguageLevel(language: any, level: any) {

           /*  if (level.id == 1) {
                this.languages.forEach( ( lang: any ) => {
                    if ( language.id !== lang.id && lang.language_level.id == 1 ) {
                        lang.language_level.id = 0;
                        lang.language_level.name = '';
                        lang.selected = false;
                    }
                });
            } */
            
            language.language_level.id = level.id;
            language.language_level.name = level.name;
            this.levelSelectDialog = false;
            
            this.$emit('input', this.languagesPayload);
            this.sortLanguages();
        }
        
        public get languagesPayload(): languagesPayload {

            this.payload = [];

            this.languages
                .filter( (lang:any) => lang.selected )
                .forEach( (lang: any) => this.payload[lang.id] = { language_level: lang.language_level.id } );

            return this.payload;
        }

        public shouldDisplayLevelsDialog(lang: any) {

            if (!lang.selected) {
                lang.language_level.id = 0;
                lang.language_level.name = '';
                return this.$emit('input', this.languagesPayload);
            }

            this.selectLangLevel(lang);
        }

        @Action('languages/fetchLanguages') fetchLanguages: any;
        @Getter('languages/languages') languagesState: any;

        @Watch('languagesState')
        onValueChange(languages: any) {
            this.setLanguages = languages;
            this.prepareSelected(this.value);
        }

        public async created() 
        {
            this.setLanguages = this.languagesState;
            this.prepareSelected(this.value);
        }
    }
